import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'
import abouts from '@/components/mode/abouts'
import realbet from '@/components/mode/realbet'
import sport from '@/components/mode/sport'
import gaming from '@/components/mode/gaming'
import joker from '@/components/mode/joker'
import concise from '@/components/mode/concise'
import lottery from '@/components/mode/lottery'
import activity from '@/components/mode/activity'
import activityInfo from '@/components/mode/activityInfo'
import app from '@/components/mode/app'
import vip from '@/components/mode/vip'


import mine from '@/components/mine/mine'
import message from '@/components/mine/message'
import center from '@/components/mine/center'
import applyagent from '@/components/mine/applyagent'
import activityRecord from '@/components/mine/activityRecord'
import fanshui from '@/components/mine/fanshui'
import betRecord from '@/components/mine/betRecord'
import transRecord from '@/components/mine/transRecord'
import transfer from '@/components/mine/transfer'
import recharge from '@/components/mine/recharge'
import withdraw from '@/components/mine/withdraw'
import bankCard from '@/components/mine/bankCard'
import welfare from '@/components/mine/welfare'



import login from '@/components/login'
import register from '@/components/register'
import gamePage from '@/components/gamePage'
import asdwl from '@/components/asdwl'
import payInfo from '@/components/payInfo'
import userredpacket from '@/components/userredpacket'







Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        },
        {
          path: '/abouts',
          name: 'abouts',
          component: abouts,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/realbet',
          name: 'realbet',
          component: realbet,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/sport',
          name: 'sport',
          component: sport,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/gaming',
          name: 'gaming',
          component: gaming,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/joker',
          name: 'joker',
          component: joker,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/concise',
          name: 'concise',
          component: concise,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/lottery',
          name: 'lottery',
          component: lottery,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/activity',
          name: 'activity',
          component: activity,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/activityInfo',
          name: 'activityInfo',
          component: activityInfo,

        }, {
          path: '/app',
          name: 'app',
          component: app,

        }, {
          path: '/vip',
          name: 'vip',
          component: vip,

        }, , {
          path: '/mine',
          name: 'mine',
          component: mine,
          meta: {
            requireAuth: true,
          },
          children: [
            {
              path: '/message',
              name: 'message',
              component: message,
            }, {
              path: '/center',
              name: 'center',
              component: center,
            }, {
              path: '/applyagent',
              name: 'applyagent',
              component: applyagent,
            }, {
              path: '/activityRecord',
              name: 'activityRecord',
              component: activityRecord,
            }, {
              path: '/fanshui',
              name: 'fanshui',
              component: fanshui,
            }, {
              path: '/betRecord',
              name: 'betRecord',
              component: betRecord,
            }, {
              path: '/transRecord',
              name: 'transRecord',
              component: transRecord,
            }, {
              path: '/transfer',
              name: 'transfer',
              component: transfer,
            }, {
              path: '/recharge',
              name: 'recharge',
              component: recharge,
              meta: {
                keepAlive: true,//是否缓存组件
                useCatch: false//是否用缓存
              }
            }, {
              path: '/withdraw',
              name: 'withdraw',
              component: withdraw,
            }, {
              path: '/bankCard',
              name: 'bankCard',
              component: bankCard,
            }, {
              path: '/welfare',
              name: 'welfare',
              component: welfare,
            },

          ]
        }

      ]
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,
    }, {
      path: '/login',
      name: 'login',
      component: login,
    }
    , {
      path: '/register',
      name: 'register',
      component: register,
    }
    , {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,
    }, {
      path: '/userredpacket',
      name: 'userredpacket',
      component: userredpacket,
    }, {
      path: '/asdwl',
      name: 'asdwl',
      component: asdwl,
    }
    , {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js